export default __webpack_public_path__ + "static/gameffy-18e106f0aa3c037f9153cfeb807896bc.png";